
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/groups/jst/GroupCategorySelector';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var stack1, helper;
  if (helper = helpers.sectionLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.sectionLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  return escapeExpression(stack1);
  }

function program3(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.group_category_selector")
  },data:data},helper ? helper.call(depth0, "assignments.group_category_selector.group_assignment_header", "Group Assignment", options) : helperMissing.call(depth0, "t", "assignments.group_category_selector.group_assignment_header", "Group Assignment", options)));
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("has_group_category"),
    'prefix': ((depth0 && depth0.prefix)),
    'checked': ((depth0 && depth0.isGroupAssignment)),
    'aria-controls': ("group_category_options"),
    'readonly': ("readonly"),
    'aria-readonly': ("true"),
    'disabled': ((depth0 && depth0.hasGroupCategoryDisabled))
  },data:data},helper ? helper.call(depth0, "has_group_category", options) : helperMissing.call(depth0, "checkbox", "has_group_category", options)))
    + "\n      ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("has_group_category"),
    'prefix': ((depth0 && depth0.prefix)),
    'checked': ((depth0 && depth0.isGroupAssignment)),
    'aria-controls': ("group_category_options"),
    'disabled': ((depth0 && depth0.hasGroupCategoryDisabled))
  },data:data},helper ? helper.call(depth0, "has_group_category", options) : helperMissing.call(depth0, "checkbox", "has_group_category", options)))
    + "\n      ";
  return buffer;
  }

function program9(depth0,data) {
  
  var stack1, helper;
  if (helper = helpers.fieldLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.fieldLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  return escapeExpression(stack1);
  }

function program11(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.group_category_selector")
  },data:data},helper ? helper.call(depth0, "assignments.group_category_selector.is_group_assignment", "This is a Group Assignment", options) : helperMissing.call(depth0, "t", "assignments.group_category_selector.is_group_assignment", "This is a Group Assignment", options)));
  }

function program13(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <label style=\"padding-left: 20px;\" class=\"checkbox\" for=\"assignment_grade_students_individually\">\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inClosedGradingPeriod), {hash:{},inverse:self.program(16, program16, data),fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.group_category_selector")
  },data:data},helper ? helper.call(depth0, "assignments.group_category_selector.grade_group_students_individually", "Assign Grades to Each Student Individually", options) : helperMissing.call(depth0, "t", "assignments.group_category_selector.grade_group_students_individually", "Assign Grades to Each Student Individually", options)))
    + "\n        </label>\n        ";
  return buffer;
  }
function program14(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_grade_students_individually"),
    'prefix': ((depth0 && depth0.prefix)),
    'checked': ((depth0 && depth0.gradeGroupStudentsIndividually)),
    'readonly': ("readonly"),
    'aria-readonly': ("true"),
    'disabled': ((depth0 && depth0.gradeIndividuallyDisabled))
  },data:data},helper ? helper.call(depth0, "grade_group_students_individually", options) : helperMissing.call(depth0, "checkbox", "grade_group_students_individually", options)))
    + "\n          ";
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_grade_students_individually"),
    'prefix': ((depth0 && depth0.prefix)),
    'checked': ((depth0 && depth0.gradeGroupStudentsIndividually)),
    'disabled': ((depth0 && depth0.gradeIndividuallyDisabled))
  },data:data},helper ? helper.call(depth0, "grade_group_students_individually", options) : helperMissing.call(depth0, "checkbox", "grade_group_students_individually", options)))
    + "\n          ";
  return buffer;
  }

function program18(depth0,data) {
  
  
  return "assignment[group_category_id]";
  }

function program20(depth0,data) {
  
  
  return "group_category_id";
  }

function program22(depth0,data) {
  
  
  return " readonly aria-readonly=\"true\" ";
  }

function program24(depth0,data,depth1) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <option value=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" "
    + escapeExpression((helper = helpers.selectedIfNumber || (depth1 && depth1.selectedIfNumber),options={hash:{},data:data},helper ? helper.call(depth0, (depth1 && depth1.groupCategoryId), (depth0 && depth0.id), options) : helperMissing.call(depth0, "selectedIfNumber", (depth1 && depth1.groupCategoryId), (depth0 && depth0.id), options)))
    + ">\n              ";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n            </option>\n            ";
  return buffer;
  }

function program26(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <div class=\"group_category_locked_explanation alert assignment-edit-group-alert\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.lockedMessage), {hash:{},inverse:self.program(29, program29, data),fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    ";
  return buffer;
  }
function program27(depth0,data) {
  
  var stack1, helper;
  if (helper = helpers.lockedMessage) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.lockedMessage); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  return escapeExpression(stack1);
  }

function program29(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.group_category_selector")
  },data:data},helper ? helper.call(depth0, "assignments.group_category_selector.group_category_locked_explanation", "Students have already submitted homework on this assignment, so group settings cannot be changed.", options) : helperMissing.call(depth0, "t", "assignments.group_category_selector.group_category_locked_explanation", "Students have already submitted homework on this assignment, so group settings cannot be changed.", options)))
    + "\n      ";
  return buffer;
  }

  buffer += "<div class=\"form-column-left\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.sectionLabel), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n\n<div class=\"form-column-right\">\n  <div class=\"border border-trbl border-round\">\n    \n    <label class=\"checkbox flush\" for=\"has_group_category\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inClosedGradingPeriod), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.fieldLabel), {hash:{},inverse:self.program(11, program11, data),fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </label>\n\n    <span id=\"has_group_category_blocked_error\" style=\"font-size: 14px; display: none; color: crimson;\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.group_category_selector")
  },data:data},helper ? helper.call(depth0, "assignments.group_category_selector.has_group_category_blocked_error", "You must remove any groups from the Assign Access section to change this setting.", options) : helperMissing.call(depth0, "t", "assignments.group_category_selector.has_group_category_blocked_error", "You must remove any groups from the Assign Access section to change this setting.", options)))
    + "\n    </span>\n\n    \n    <div id=\"group_category_options\" style=\""
    + escapeExpression((helper = helpers.hiddenUnless || (depth0 && depth0.hiddenUnless),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.groupCategoryId), options) : helperMissing.call(depth0, "hiddenUnless", (depth0 && depth0.groupCategoryId), options)))
    + "\">\n      <div class=\"nested\" style=\"padding-left: 32px;\">\n        ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hideGradeIndividually), {hash:{},inverse:self.noop,fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n        \n        <div id=\"assignment_group_category\">\n          <label id=\"assignment_group_category_id_label\" for=\"group_category_id\" style=\"padding-left: 0px;\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.group_category_selector")
  },data:data},helper ? helper.call(depth0, "assignments.group_category_selector.group_set", "Group Set", options) : helperMissing.call(depth0, "t", "assignments.group_category_selector.group_set", "Group Set", options)))
    + "\n          </label>\n          <select id=\"assignment_group_category_id\"\n            style=\"margin-left: 0px;\"\n            name=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.nested), {hash:{},inverse:self.program(20, program20, data),fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inClosedGradingPeriod), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            aria-labelledby=\"assignment_group_category_id_label\" "
    + escapeExpression((helper = helpers.disabledIf || (depth0 && depth0.disabledIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.groupCategoryIdDisabled), options) : helperMissing.call(depth0, "disabledIf", (depth0 && depth0.groupCategoryIdDisabled), options)))
    + ">\n            <option value=\"blank\" "
    + escapeExpression((helper = helpers.selectedIf || (depth0 && depth0.selectedIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.groupCategoryUnselected), options) : helperMissing.call(depth0, "selectedIf", (depth0 && depth0.groupCategoryUnselected), options)))
    + ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.group_category_selector")
  },data:data},helper ? helper.call(depth0, "select_a_group_category_295f7a34", "Select a group category", options) : helperMissing.call(depth0, "t", "select_a_group_category_295f7a34", "Select a group category", options)))
    + "</option>\n            ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.groupCategories), {hash:{},inverse:self.noop,fn:self.programWithDepth(24, program24, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            <option value=\"new\"\n              "
    + escapeExpression((helper = helpers.hiddenIf || (depth0 && depth0.hiddenIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.inClosedGradingPeriod), options) : helperMissing.call(depth0, "hiddenIf", (depth0 && depth0.inClosedGradingPeriod), options)))
    + "\n              "
    + escapeExpression((helper = helpers.hiddenIf || (depth0 && depth0.hiddenIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.groupCategoryIdDisabled), options) : helperMissing.call(depth0, "hiddenIf", (depth0 && depth0.groupCategoryIdDisabled), options)))
    + "\n              "
    + escapeExpression((helper = helpers.hiddenIf || (depth0 && depth0.hiddenIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.cannotManageGroups), options) : helperMissing.call(depth0, "hiddenIf", (depth0 && depth0.cannotManageGroups), options)))
    + ">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.group_category_selector")
  },data:data},helper ? helper.call(depth0, "create_new_group_set_ab5e6d9f", "[ Create New Group Set ]", options) : helperMissing.call(depth0, "t", "create_new_group_set_ab5e6d9f", "[ Create New Group Set ]", options)))
    + "\n            </option>\n          </select>\n          <div id=\"create-group-set-modal-mountpoint\"></div>\n          <div id=\"assignment_group_category_id_errors\"></div>\n        </div>\n        <span id=\"assignment_group_category_id_blocked_error\" style=\"font-size: 14px; display: none; color: crimson\"></span>\n        <div>\n          <button class=\"Button\" type=\"button\" id=\"create_group_category_id\"\n            "
    + escapeExpression((helper = helpers.disabledIf || (depth0 && depth0.disabledIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.inClosedGradingPeriod), options) : helperMissing.call(depth0, "disabledIf", (depth0 && depth0.inClosedGradingPeriod), options)))
    + "\n            "
    + escapeExpression((helper = helpers.disabledIf || (depth0 && depth0.disabledIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.groupCategoryIdDisabled), options) : helperMissing.call(depth0, "disabledIf", (depth0 && depth0.groupCategoryIdDisabled), options)))
    + "\n            "
    + escapeExpression((helper = helpers.disabledIf || (depth0 && depth0.disabledIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.cannotManageGroups), options) : helperMissing.call(depth0, "disabledIf", (depth0 && depth0.cannotManageGroups), options)))
    + ">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.group_category_selector")
  },data:data},helper ? helper.call(depth0, "new_group_category_66be9cbd", "New Group Category", options) : helperMissing.call(depth0, "t", "new_group_category_66be9cbd", "New Group Category", options)))
    + "\n          </button>\n          <div id=\"create-group-set-modal-mountpoint\"></div>\n        </div>\n      </div>\n    </div>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.groupCategoryLocked), {hash:{},inverse:self.noop,fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  